module.exports = __webpack_public_path__ + "img/source_book-item1.9a63aaaa.png";